import React from 'react';
import './isi.scss';
import { isiData } from './isiData';
import IsiLists from './IsiLists';
import IsiList from './IsiList';

function IsiSection({ index, box }) {
  const { head, list, items, nogap, mixed, padding } = isiData[index];

  return (
    <div
      className={
        nogap ? 'isi__body__paragraph isi__body__paragraph--nogap' : 'isi__body__paragraph'
      }
    >
      {head && <h6 className="isi__body__bold">{head}</h6>}
      {list && <p className="isi__body__text">{list}</p>}
      {mixed && (
        <p>
          {mixed.copy.map((copy, i) => {
            return mixed.weight[i] === 'reg' ? (
              <span className="isi__body__text" key={`mixed-${i}`}>
                {copy}
              </span>
            ) : (
              <strong
                key={`mixed-${i}`}
                className={mixed.weight[i] === 'bold' ? 'isi__body__bold' : 'isi__body__med'}
              >
                {copy}
              </strong>
            );
          })}
        </p>
      )}
      {items && items.length > 1 && (
        <div className="isi__body__list isi__body__list--wrap">
          {items.map((item, i) => {
            return (
              <IsiList box={box} item={item} wrap={true} key={`list-${index}-${i}`} index={index} />
            );
          })}
        </div>
      )}
      {items && items.length < 2 && <IsiLists items={items} index={index} padding={padding} />}
    </div>
  );
}

export default IsiSection;
